import { Injectable, computed, inject, signal } from '@angular/core';
import {
  IntrospectClient,
  IntrospectRequest,
} from '@rhapsody/ngx-api-key-client';

import { IntrospectKeysState } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class IntrospectKeysService {
  readonly introspectClient = inject(IntrospectClient);

  readonly #state = signal<IntrospectKeysState>({
    key: '',
    introspectResponse: '',
    introspectError: false,
  });

  readonly state = computed(() => this.#state());
  readonly key = computed(() => this.#state().key);
  readonly introspectResponse = computed(
    () => this.#state().introspectResponse
  );
  readonly introspectError = computed(() => this.#state().introspectError);

  public introspect(body: IntrospectRequest) {
    this.introspectClient.introspect(body).subscribe({
      next: (value) => {
        const valueToStr = JSON.stringify(value, null, 2);
        this.setResponse(valueToStr, false);
      },
      error: (err) => {
        const errorToStr = JSON.stringify(err, null, 2);
        this.setResponse(errorToStr, true);
      },
    });
  }

  private setResponse(value: string, introspectError: boolean = false) {
    this.#state.update((state) => ({
      ...state,
      introspectResponse: value,
      introspectError,
    }));
  }

  public clear() {
    this.#state.update(() => ({
      key: '',
      introspectResponse: '',
      introspectError: false,
    }));
  }
}
